import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Register, NodeViewComponent } from '@xanadu/core';
import { Node, Endpoint, Realm, Syndicate, Cast, Import, NodeModel } from '@xanadu/model';
import { CastCache, EndpointCache } from '@xanadu/cache';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-import-view',
    templateUrl: './import-view.component.html',
    styleUrls: ['./import-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('import-view')
export class ImportViewComponent extends NodeViewComponent<Import | Endpoint | Realm | Syndicate | Cast> {
    private readonly endpointCache = inject(EndpointCache);
    private readonly castCache = inject(CastCache);

    protected get nodeType(): string | undefined {
        return 'import';
    }

    protected getPanel(model: NodeModel) {
        const node = model.node;
        const custome = model.custome;

        if (node instanceof Realm) {
            return {
                node: node,
                component: 'realm-panel'
            };
        } else if (node instanceof Endpoint) {
            return {
                node: node,
                custome,
                component: 'endpoint-panel'
            };
        } else if (node instanceof Syndicate) {
            return {
                node: node,
                component: 'syndicate-panel'
            };
        } else if (node instanceof Cast) {
            return {
                node: node,
                custome,
                component: 'cast-panel'
            };
        }
    }

    protected delete(node: Node): Observable<Endpoint | Realm | Syndicate | Cast> {
        return this.dataService.delete<Endpoint | Realm | Syndicate | Cast>(node as any)
            .pipe(tap(node => {
                if (node instanceof Endpoint) {
                    this.endpointCache.update();
                } else if (node instanceof Cast) {
                    this.castCache.update();
                }
            }));
    }
}
